const project = {
  slug: "aeye-ai-chatbot-platform",
  title: "aEye - AI Chatbot SaaS Platform",
  oneLiner:
    "Train an AI chatbot on your own business knowledge and deploy it to your website and WhatsApp in minutes.",
  role: ["Full-stack Developer", "AI/ML Developer"],
  category: "AI/ML",
  clientOrOrg: "aEye",
  timeframe: { start: "2025-01", status: "In Progress" },
  domain: ["SaaS", "AI", "Chatbots", "RAG"],
  tech: [
    "Next.js 16",
    "React 19",
    "TypeScript",
    "MySQL",
    "NextAuth v5",
    "Stripe",
    "Anthropic Claude API",
    "WhatsApp Business API",
    "Tailwind CSS"
  ],
  links: {live: "https://aeye.lk"},
  gallery: [
    { src: "/assets/aeye/aeye-1.png", alt: "aEye dashboard showing bot management and analytics" },
    { src: "/assets/aeye/aeye-2.png", alt: "aEye knowledge base interface for uploading documents and crawling URLs" },
    { src: "/assets/aeye/aeye-3.png", alt: "aEye subscription plans page with Stripe integration" },
  ],
  impact: [
    "Gave small and mid-sized businesses an affordable way to launch a custom AI assistant trained on their own content, without writing code.",
    "Replaced static FAQ pages and slow email support with a 24/7 AI agent that answers from the business's own documents.",
    "Unified website chat and WhatsApp conversations under a single bot and a single inbox.",
    "Turned chatbot conversations into a lead capture and qualification channel for sales teams."
  ],
  responsibilities: [
    "Designed and built the full multi-tenant architecture, from database schema to dashboard UI.",
    "Built the knowledge ingestion pipeline that crawls URLs, parses uploaded documents, and indexes them for retrieval.",
    "Implemented the RAG chat engine on top of the Anthropic Claude API.",
    "Integrated Stripe subscription billing, plan limits, and webhook-driven entitlement updates.",
    "Built the WhatsApp Business API integration including webhook handling and message routing.",
    "Developed the autonomous AI blog bot and its scheduled publishing pipeline.",
    "Built the hidden admin panel for platform operations and user management.",
    "Dockerized the full Next.js + MySQL stack with multi-stage builds for optimized production images.",
    "Built a GitHub Actions CI/CD pipeline that auto-deploys to a Hetzner VPS on merge to main, with zero-downtime container restarts."
  ],
  features: [
    "Train custom chatbots on uploaded files, pasted text, or crawled website URLs",
    "Embeddable website chat widget with branded styling",
    "WhatsApp Business integration for the same bot",
    "Conversation history and lead capture per bot",
    "Stripe-powered subscriptions with usage limits",
    "AI blog bot that auto-publishes SEO content on a schedule",
    "Bot management dashboard with knowledge base and settings per bot",
    "Admin panel for user, plan, and platform management"
  ],
  architecture: [
    "Next.js 16 App Router with React 19 server components for the dashboard, marketing site, and API routes",
    "MySQL with a manually managed schema (no ORM) for full control over multi-tenant data",
    "NextAuth v5 for authentication with role-based access for tenants and admins",
    "RAG pipeline that chunks, embeds, and retrieves knowledge per bot before calling Claude",
    "Stripe webhooks drive subscription state and feature gating",
    "WhatsApp Business webhooks bridged into the same conversation pipeline as the web widget",
    "Cron-driven jobs for the AI blog bot and background maintenance tasks",
    "Dockerized stack with multi-stage builds, running on a Hetzner VPS",
    "GitHub Actions CI/CD that rebuilds and ships containers on merge to main with zero-downtime restarts"
  ],
  seo: {
    title: "aEye - AI Chatbot SaaS Platform Case Study",
    description:
      "Multi-tenant SaaS built with Next.js 16, React 19, and the Anthropic Claude API. Lets businesses train a RAG chatbot on their own content and deploy it to web and WhatsApp."
  },
  cover: "/assets/aeye/aeye-featured.png"
};

export default project;
